export {
	DialogBody,
	DialogClose,
	DialogDescription,
	DialogFooter,
	DialogFooterTemplate,
	DialogHeader,
	DialogHeaderTemplate,
	DialogTitle,
	DialogTrigger,
} from "ics-ui-kit/components/dialog";

export { Dialog } from "./Dialog";
export { DialogContent } from "./DialogContent";

export { isFromModal } from "./utils";
